import { message } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate ,useLocation } from "react-router-dom";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loginUser, setLoginUser] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setLoginUser(user);
    }
  }, []);

  const logoutHandler = () => {
    localStorage.removeItem("user");
    message.success("Logout Successfully");
    // window.location.reload();
    navigate("/login");
  };

  return (
    <div className="bg-white dark:bg-gray-900">
      <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="relative flex items-center justify-between">
          <Link
            to="/"
            aria-label="Minimo"
            title="minimo"
            className="inline-flex items-center"
          >
            <svg
              className="w-8 text-yellow-200"
              viewBox="0 0 24 24"
              strokeLinejoin="round"
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
              stroke="currentColor"
              fill="none"
            >
              <rect x="3" y="1" width="7" height="12" />
              <rect x="3" y="17" width="7" height="6" />
              <rect x="14" y="1" width="7" height="6" />
              <rect x="14" y="11" width="7" height="12" />
            </svg>
            <span className="ml-2 text-3xl font-bold tracking-wide text-gray-100 uppercase">
              Minimo
            </span>
          </Link>
          <ul className="flex items-center hidden space-x-8 lg:flex">
            <li>
              <Link
                to="/"
                aria-label="Home"
                title="Home"
                className={`text-xl text-gray-100 duration-200 hover:text-teal-accent-400 ${
        location.pathname === "/" ? "font-bold text-amber-200" : ""
      } tracking-wide transition-colors active:text-amber-100`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard"
                aria-label="dashbord"
                title="dashbord"
                className={`text-xl text-gray-100 duration-200 hover:text-teal-accent-400 ${
        location.pathname === "/dashboard" ? "font-bold text-amber-200" : ""
      } tracking-wide transition-colors active:text-amber-100`}
              >
                Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/transaction"
                aria-label="transaction"
                title="transaction"
                className={`text-xl text-gray-100 duration-200 hover:text-teal-accent-400 ${
        location.pathname === "/transaction" ? "font-bold text-amber-200" : ""
      } tracking-wide transition-colors active:text-amber-100`}
              >
                Transaction
              </Link>
            </li>
            <li>
              <button
                className="font-semibold text-lg hover:text-red-400 inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                aria-label="Log out"
                title="log out"
                onClick={logoutHandler}
              >
                {/* {loginUser && loginUser.name} <img className="ml-1 w-6 h-6" src="logout.png" alt="logout" /> */} Logout
              </button>
            </li>
          </ul>
          <div className="lg:hidden">
            <button
              aria-label="Open Menu"
              title="Open Menu"
              className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg className="w-5 text-white" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div className="absolute top-0 left-0 w-full z-40">
                <div className="p-5 bg-white dark:bg-teal-300 rounded shadow-lg">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <Link
                        to="/"
                        aria-label="Company"
                        title="Company"
                        className="inline-flex items-center"
                      >
                        <svg
                          className="w-8 text-amber-400"
                          viewBox="0 0 24 24"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeMiterlimit="10"
                          stroke="currentColor"
                          fill="none"
                        >
                          <rect x="3" y="1" width="7" height="12" />
                          <rect x="3" y="17" width="7" height="6" />
                          <rect x="14" y="1" width="7" height="6" />
                          <rect x="14" y="11" width="7" height="12" />
                        </svg>
                        <span className="ml-2 text-3xl font-bold tracking-wide text-gray-800 uppercase">
                          Minimo
                        </span>
                      </Link>
                    </div>
                    <div>
                      <button
                        aria-label="Close Menu"
                        title="Close Menu"
                        className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul className="space-y-4">
                      <li>
                        <a
                          href="/"
                          aria-label="Home"
                          title="Home"
                          className={`font-semibold hover:text-yellow-200 tracking-wide   ${location.pathname === "/" ? "text-purple-700 " : " text-slate-700 " }transition-colors duration-200 `}
                        >
                           Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="/dashboard"
                          aria-label="dashbord"
                          title="dashbord"
                          className={`font-semibold hover:text-yellow-200 tracking-wide   ${location.pathname === "/dashboard" ? "text-purple-700 " : " text-slate-700 "}transition-colors duration-200 `}
                        >
                          Dashboard
                        </a>
                      </li>
                      <li>
                        <a
                          href="/transaction"
                          aria-label="transaction"
                          title="transaction"
                          className={`font-semibold hover:text-yellow-200 tracking-wide   ${location.pathname === "/transaction" ? "text-purple-700 " : " text-slate-700 "}transition-colors duration-200 `}
                        >
                          Transaction
                        </a>
                      </li>

                      <li className=" bg-black">
                        <button
                          className="font-semibold inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white hover:text-red-400 transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                          aria-label="Logout"
                          title="Logout"
                          onClick={logoutHandler}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
